<template>
  <div>
    <div v-for="item in keysList" :key="item">
      <total-price-modal
        :ref="`totalPriceModal${item}`"
        :arr="arr"
        :form="form"
        :item="item"
        :InquiryList="InquiryList"
        :UnitList="UnitList"
        :type="type"
        :isAdd="isAdd"
        @removeRow="removeRow"
      ></total-price-modal>
    </div>
    <a-row type="flex" justify="center">
      <a-col :span="2">
        <a-button type="primary" icon="plus" @click="addRow" :disabled="!isEdit">添加</a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import totalPriceModal from './totalPriceModal.vue'
export default {
  props: {
    arr: {
      type: Array,
      default: function () {
        return []
      },
    },
    InquiryList: [Array],
    UnitList: [Array],
    form: [Object],
    type: [String],
  },
  components:{
    totalPriceModal
  },
  data() {
    return {
      id: 0,
      keysList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      labelCol3: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol3: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      colSpan: 6,
      isAdd:false
    }
  },
  computed: {
    isEdit() {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
  },
  created() {
    this.init()
  },
  methods: {
    getData() {
      const arr = []
      this.keysList.forEach( item => {
        const inquiryProductId = this.form.getFieldValue(`inquiryProductId[${item}]`)
        console.log('排查InquiryList',inquiryProductId);
        const data = {
          inquiryProductId,
          name: this.InquiryList.filter((item1) => item1.id === inquiryProductId)[0].name,
          lastInquiryRecordId: this.InquiryList.filter((item1) => item1.id === inquiryProductId)[0]
            .lastInquiryRecordId,
          spec: this.InquiryList.filter((item1) => item1.id === inquiryProductId)[0].spec,
          num: this.form.getFieldValue(`num[${item}]`),
          unit: this.form.getFieldValue(`unit[${item}]`),
          price: this.form.getFieldValue(`price[${item}]`),
          totalPrice:
            Number(this.form.getFieldValue(`num[${item}]`)) * Number(this.form.getFieldValue(`price[${item}]`)),
        }
        arr.push(data)
      })
      return arr
    },
    // 初始化
    init() {
      this.keysList = []
      this.id = 0
      const arr = [0]
      if(this.type === this.$sysInfo.MODAL_ADD){
        this.$nextTick(() => {
          this.$refs['totalPriceModal0'][0].initTotalPrice(0)
        })
      }else{
        this.$nextTick(() => {
          this.$refs['totalPriceModal0'][0].initTotalPrice(Number(this.arr[0].num) * Number(this.arr[0].price))
        })
      }
      
      if (this.arr.length !== 0) {
        for (let i = 1; i < this.arr.length; i++) {
          arr.push(i)
          this.id = this.id + 1
        }
      }
      this.keysList = arr
      console.log('arr', this.arr)
      console.log('init', this.keysList)
      console.log('unit', this.UnitList)
    },
    // 移除某行
    removeRow(k) {
      if (this.keysList.length === 1) {
        // 如果存在可以移除所有行的情况，把条件改为this.keysList.length === 0即可
        this.$refs[`totalPriceModal${this.item}`][0].clear(k)
        return
      }
      this.keysList = this.keysList.filter((item) => item !== k)
      console.log('del', this.keysList)
    },
    // 新增一行
    addRow() {
      this.id = this.id + 1
      this.keysList = this.keysList.concat(this.id)
      console.log('add', this.keysList)
      this.isAdd = true
    },
    clear(item) {
      let inquiryProductIdArr = this.form.getFieldValue('inquiryProductId')
      inquiryProductIdArr[item] = ''
      let numArr = this.form.getFieldValue('num')
      numArr[item] = ''
      let unitArr = this.form.getFieldValue('unit')
      unitArr[item] = ''
      let priceArr = this.form.getFieldValue('price')
      priceArr[item] = ''
      this.form.setFieldsValue({
        inquiryProductId: inquiryProductIdArr,
        num: numArr,
        unit: unitArr,
        price: priceArr,
      })
    }
  },
}
</script>

<style lang="less">
.ant-form-extra{
  color: rgba(23, 145, 255, 1);
}
</style>

